import { combineReducers } from "redux";
import welcomes from "../features/admin/aboutus/welcomes/Slice";
import what_we_ares from "../features/admin/aboutus/what_we_ares/Slice";
import what_media_dos from "../features/admin/aboutus/what_media_dos/Slice";

const aboutus = combineReducers({
    welcomes: welcomes,
    what_we_ares:what_we_ares,
    what_media_dos:what_media_dos,
  });
  
  export default aboutus;